import '@shared/i18n/i18n';
import { configureApp } from './app/bootstrap/configureApp';
import { mountApp } from './app/bootstrap/mountApp';

configureApp();
mountApp();
